//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum SmsType {
	Normal = 0,
	Fast = 1,
	Notification = 2
}
